export const SCROLL_TO = 'SCROLL_TO';
export const SCROLL_COMPLETE = 'SCROLL_COMPLETE';
export const TRIP_TRAVELLER_TYPE = 'TRIP_TRAVELLER_TYPE';
export const SET_ACCORDION_OPEN = 'SET_ACCORDION_OPEN';
export const CLEAR_ACCORDION_OPEN = 'CLEAR_ACCORDION_OPEN';
export const TRAVELLER_FORM_ERRORS = 'TRAVELLER_FORM_ERRORS';
export const TRAVELLER_PAYMENT = 'TRAVELLER_PAYMENT';
export const TRAVELLER_JOURNEY_SELECTION = 'TRAVELLER_JOURNEY_SELECTION';
export const ACCEPT_LEGAL = 'ACCEPT_LEGAL';
export const SELECT_PLAN_PAGE_FOCUS = 'SELECT_PLAN_PAGE_FOCUS';
export const COVERME_TRIP_TRAVELLER_TYPE = 'COVERME_TRIP_TRAVELLER_TYPE';

export interface TravellerSelection {
  scrollPage?: string;
  paxId?: number;
  dependentId?: number;
  isFamily?: boolean;
  isSingleTrip?: boolean;
  openAccordion?: Record<number, boolean>;
  showPageError?: boolean;
  individualPayment?: string;
  departure?: string;
  destinations?: string[];
  legalConsent?: boolean;
  selectPlanPageFocus?: string;
}

export interface TravellerJourneyPayload {
  departure?: string;
  destinations?: string[];
}

export interface ScrollActionPayload {
  scrollPage: string;
  paxId?: number;
  dependentId?: number;
}
